// tslint:disable:max-line-length

import React from 'react';

export const DatatypeDate = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M.5,0V3h15V0Zm0,4V16h15V4Zm5,2h2V8h-2Zm3,0h2V8h-2Zm3,0h2V8h-2Zm-9,3h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-9,3h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Z" />
    </svg>
  );
};
